const e=["light","regular","medium","bold"],t={weight:{type:"enum",className:"rt-r-weight",values:e,responsive:!0}};export{t as weightPropDef};
//# sourceMappingURL=weight.prop.js.map
